$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
Util = require 'app/scripts/lib/util'
rpc = require 'app/scripts/network/rpc'

module.exports = SessionStatus =
  start: ->
    rpc.on 'ready', =>
      $(window).on 'beforeunload', =>
        @markCurrentBoardAsViewed()
        return

    rpc.on 'updateModels deleteModels', ({ idModelChannel }) =>
      if idModelChannel? && idModelChannel == Controller.getCurrentBoard()?.id
        @scheduleMarkCurrentBoardAsViewed()
      return

  markCurrentBoardAsViewed: ->
    clearTimeout @_markAsViewedTimeout
    Controller.getCurrentBoard()?.markAsViewed()

  scheduleMarkCurrentBoardAsViewed: ->
    # We're depending on the fact that the timeout will be cleared on view changes,
    # so the timeout won't fire if the current board changes in the next minute.
    clearTimeout @_markAsViewedTimeout

    @_markAsViewedTimeout =
      setTimeout (=> @markCurrentBoardAsViewed()), Util.getMs(minutes: 5)
